import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Property, SectionConfig } from '../../../dto/response/template.config';
import { TemplateConfigService } from '../../../service/template-config.service';

@Component({
  selector: 'app-header-logo',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './header-logo.component.html',
  styleUrl: './header-logo.component.scss',
})
export class HeaderLogoComponent {
  logo: Property | undefined;

  constructor(private templateConfigService: TemplateConfigService) {}

  _config: SectionConfig;

  @Input()
  set config(config: SectionConfig) {
    this._config = config;
    this.logo = this.templateConfigService.findConfig(config, 'logo');
  }
}
